import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { DocumentSupportDetailService } from 'src/app/services/shopping/document-support-detail.service';
import { DocumentSupportModel } from './../../../../models/shopping/document-support.model';
import { DocumentSupportService } from './../../../../services/shopping/document-support.service';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { DocumentSupportTableModel } from 'src/app/models/shopping/document-support-table.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { DocumentSupportDetailTableModel } from 'src/app/models/shopping/document-support-detail-table.model';
import { HeaderService } from 'src/app/services/header/header.service';

@Component({
  selector: 'app-document-support',
  templateUrl: './document-support.component.html',
  styleUrls: ['./document-support.component.scss'],
  standalone: false
})
export class DocumentSupportComponent implements OnInit {

  documentSupportContract: DocumentSupportModel = new DocumentSupportModel();
  documentSupportId: number = 0;


  generalHeader: ColumnResponseModel[] = [];
  generalData: PagedResponseModel<DocumentSupportTableModel> = new PagedResponseModel<DocumentSupportTableModel>();
  detailHeader: ColumnResponseModel[] = [];
  detailData: PagedResponseModel<DocumentSupportDetailTableModel> = new PagedResponseModel<DocumentSupportDetailTableModel>();
  listStoreConsolidated: ColumnResponseModel = new ColumnResponseModel();
  projectName = ProjectName.projectName;

  activeTabIndex = 0;
  ascendant: boolean = true;
  columnSort: string | null = null;
  filters: ColumnResponseModel[] = []
  limit: number = 10;
  nameWindow: string = 'Documento Soporte';
  page: number = 1;
  previousSort: { field: string; isAscsendant: number };
  tableActions: TableAction[] = [
    {
      label: 'Editar',
      icon: 'pi pi-pencil',
      action: 'edit'
    },
  ];

  constructor(
    private documentSupportService: DocumentSupportService,
    private documentSupportDetailService: DocumentSupportDetailService,
    private router: Router,
    private title: Title,
    private headerService: HeaderService
  ) {
  }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    const filters = localStorage.getItem('document-support');
    if (filters) this.filters = JSON.parse(filters);
    await Promise.all([
      this.getColumnsForGeneralConsultation(),
      this.getDocumentsSupportWithPagination(),
    ]);
  }

  public async handleTabChange(tabIndex: number) {
    this.generalHeader.length = this.generalHeader.length === 1 ? 0 : this.generalHeader.length;
    this.detailHeader.length = this.detailHeader.length === 1 ? 0 : this.detailHeader.length;

    if (this.activeTabIndex === tabIndex) return;

    this.page = 1;
    this.limit = 10;
    this.activeTabIndex = tabIndex;


    this.page = 1;

    switch (this.activeTabIndex) {
      case 0:
        await Promise.all([
          this.getColumnsForGeneralConsultation(),
          this.getDocumentsSupportWithPagination()
        ]);
        this.generalData = {
          ...this.generalData,
          currentPage: 1,
          pageSize: 10
        };
        break;
      case 1:
        await Promise.all([
          this.getColumnsForDetailConsultation(),
          this.getAllDocumentsSupportDetailsWithPagination()
        ]);
        this.detailData = {
          ...this.detailData,
          currentPage: 1,
          pageSize: 10
        };
        break;
    }
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    switch (this.activeTabIndex) {
      case 0:
        await this.getDocumentsSupportWithPagination()
        break;
      case 1:
        await this.getAllDocumentsSupportDetailsWithPagination()
        break;
    }
  }

  async onExport() {
    switch (this.activeTabIndex) {
      case 0:
        await this.exportGeneralConsultation();
        break;
      case 1:
        await this.exportDetailConsultation();
        break;
    }
  }

  async exportGeneralConsultation() {
    try {
      const blob = await firstValueFrom(this.documentSupportService.exportGeneralConsultation(this.filters, this.columnSort, this.ascendant));
      if (blob) {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Documentos soporte.xlsx'; // El nombre del archivo
        a.click();
        window.URL.revokeObjectURL(url);
      }

    } catch (error) {
      console.error('Error al exportar los documentos.', error);
    }
  }

  async exportDetailConsultation() {
    try {
      const blob = await firstValueFrom(this.documentSupportDetailService.exportDetailConsultation(this.filters, this.columnSort, this.ascendant));
      if (blob) {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Documento Soporte Detalle.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error('Error al exportar los documentos detalle.', error);
    }
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters
      .map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index)
      .map((item: any) => item.value);

    this.filters = this.removeDuplicates(filters);

    // Procesar cada filtro
    this.filters.forEach((filter: any) => this.processFilter(filter));
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }


  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filters = this.filters.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filters.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  clearForm() {
    this.documentSupportContract = new DocumentSupportModel();
    this.documentSupportId = this.documentSupportContract.documentSupportId;
    this.router.navigate([`/document-support/${this.documentSupportId}`]);
  }

  async getColumnsForGeneralConsultation() {
    try {
      if (this.generalHeader.length === 0) {
        this.generalHeader = await firstValueFrom(this.documentSupportService.getColumnsForGeneralConsultation());
      }
      this.listStoreConsolidated = new ColumnResponseModel;
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta general.', error);
    }
  }

  async getDocumentsSupportWithPagination() {
    try {
      this.generalData = await firstValueFrom(this.documentSupportService.getDocumentSupportWithPagination(this.page, this.limit, this.columnSort, this.ascendant, this.filters))
    } catch (error) {
      console.error('Error al buscar los documentos.', error);
    }
  }


  async getColumnsForDetailConsultation() {
    try {
      if (this.detailHeader.length === 0) {
        this.detailHeader = await firstValueFrom(this.documentSupportDetailService.getColumnsForDetailConsultation());
      }
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta general.', error);
    }
  }

  async getAllDocumentsSupportDetailsWithPagination() {
    try {
      this.detailData = await firstValueFrom(this.documentSupportDetailService.getAllDocumentsSupportDetailsWithPagination(this.page, this.limit, this.columnSort, this.ascendant, this.filters));
    } catch (error) {
      console.error('Error al buscar los detalles de los documentos soporte.', error);
    }
  }

  goToBack(event: Event) {
    event.preventDefault();
    this.router.navigate(['/document-support']);
  }

  goToHome(event: Event) {
    event.preventDefault();
    this.router.navigate(['/main']);
  }

  newDocumentSupport() {
    this.router.navigate(['/document-support/register']);
  }

  onAction(event: { action: string, item?: DocumentSupportTableModel, selectedItems?: number[] }) {
    if (event.action === 'edit' && event.item) {
      this.router.navigate([`/document-support/register/${event.item.documentSupportId}`]);
    }
  }

}

